var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2484 0.0156295 47.9844 10.7516 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24ZM4.36694 23.9996C4.36694 34.8445 13.1584 43.636 24.0033 43.636C34.8427 43.6228 43.6264 34.839 43.6397 23.9996C43.6397 13.1548 34.8482 4.36328 24.0033 4.36328C13.1584 4.36328 4.36694 13.1548 4.36694 23.9996Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M34.9102 21.8192H26.1829V13.092C26.1829 11.887 25.2061 10.9102 24.0011 10.9102C22.7961 10.9102 21.8192 11.887 21.8192 13.092V21.8192H13.092C11.887 21.8192 10.9102 22.7961 10.9102 24.0011C10.9102 25.2061 11.887 26.1829 13.092 26.1829H21.8192V34.9102C21.8192 36.1151 22.7961 37.092 24.0011 37.092C25.2061 37.092 26.1829 36.1151 26.1829 34.9102V26.1829H34.9102C36.1151 26.1829 37.092 25.2061 37.092 24.0011C37.092 22.7961 36.1151 21.8192 34.9102 21.8192Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addBlack.27009e2dba401be1af185445f2b51e79.svg";